import React, { Component } from 'react';
import styles from './pictureInPicture.scss';
import { ArticleTileContext } from '../../../globalState/articleTileContext';
import { IPipGraphic } from '../article-tile.d';
import { PipAttributeType } from '../../../../Common/enums';

interface IPictureInPictureProps {
    pipElements: IPipGraphic[];
    pipType: PipAttributeType;
}

export default class PictureInPicture extends Component<IPictureInPictureProps, {}> {
    static contextType = ArticleTileContext;
    declare context: React.ContextType<typeof ArticleTileContext>;

    constructor(props) {
        super(props);
    }

    public render() {
        const culture = this.context?.culture ?? '';

        return (
            <div className={styles.pip_container}>
                {this.props.pipElements.map((pipElement, index) => {
                    return (
                        <div key={index} className={styles.pip_item}>
                            <img alt={pipElement.pictureInPictureGraphic.altTexts
                                .find(alt => culture.includes(alt.languageCode))?.text || ''}
                                className={styles.pip_icon} src={pipElement.pictureInPictureGraphic.imageUrl} />
                        </div>
                    );
                })}
            </div>
        );
    }
}
